<template>
    <div>
        <div class="title">
            <div class="title-backgruond"></div>
            <div v-if="(userType === 1)" class="title-body">
                <div>恭喜你！在本次直播指导中获得<span v-if="(coin > 0)">第{{ rank }}名</span><span
                        v-if="(coin > 0 && winnerCoin > 0)">和</span>
                    <span v-if="(winnerCoin > 0)">进步奖</span>

                    。快来领取奖励吧！
                </div>
                <div>
                    <div class="winner" v-if="(coin > 0)">
                        <img src="./../../images/l-coin.png" alt="">
                        <span>+{{ coin }}</span>
                    </div>
                    <div class="winner" v-if="(winnerCoin > 0)"><img src="./../../images/l-coin.png" alt=""><span>+{{
                            winnerCoin
                    }}</span></div>
                </div>
            </div>
            <div v-else class="title-body">
                <div>
                    {{ text }}
                </div>

            </div>

        </div>
    </div>
</template>
<script>
export default {
    props: {
        rank: {
            default: null
        },
        userType: {
            default: 1
        },
        coin: {
            type: Number,
            default: 0
        },
        winnerCoin: {
            default: 0
        },
    },
    data() {
        return {
            text: ""
        }
    },
    mounted() {
        if (this.userType === 2) {
            this.text = "本次直播指导的出勤率＜50%， 不能开启LILY币奖励哦~"
        }
        if (this.userType === 3) {
            this.text = "你没有参与本次直播指导， 下次要记得准时出席，就有机会获得LILY币奖励哦~"
        }
    }

}
</script>
<style scoped lang="stylus">
@import "./index.styl"
</style>